import React from 'react';
import { Card } from 'react-native-paper';
import { FormCard } from './FormCard';
import { YesNoRadioGroup } from '../components/YesNoRadioGroup';
import { getLabel, YesNoLabels } from './formValuesModel';
export const CookingCard = ({ values, readOnly, handleChange }) => {
    return (<FormCard>
      <Card.Content>
        <YesNoRadioGroup labelText={getLabel('selfCook', YesNoLabels) || ''} valueName="selfCook" value={values.selfCook} handleChange={handleChange} readOnly={readOnly}/>
        <YesNoRadioGroup labelText={getLabel('elseCook', YesNoLabels) || ''} valueName="elseCook" value={values.elseCook} handleChange={handleChange} readOnly={readOnly}/>
        <YesNoRadioGroup labelText={getLabel('mealPrep', YesNoLabels) || ''} valueName="mealPrep" value={values.mealPrep} handleChange={handleChange} readOnly={readOnly}/>
      </Card.Content>
    </FormCard>);
};
